import type { Nullable } from 'corgi-types';

interface ErrorWithMessage {
  message: string;
}

const isErrorWithMessage = (error: unknown): error is ErrorWithMessage =>
  typeof error === 'object' && error !== null && Object.hasOwnProperty.call(error, 'message');

export const getMessageFromError = (error: unknown): Nullable<string> => {
  if (typeof error === 'string') {
    return error;
  } else if (isErrorWithMessage(error)) {
    return error.message;
  }

  return null;
};
